import {
  BlankContractStatuses,
  CampaignStatuses,
  LaunchDateStatuses,
  MarketingStatuses,
} from '@urbanx/agx.campaigns.client'

export interface CampaignsDashboardFilterState {
  agencyIds?: string[]
  campaignStatuses?: CampaignStatuses[]
  blankContractStatuses?: BlankContractStatuses[]
  launchDateStatuses?: LaunchDateStatuses[]
  marketingStatuses?: MarketingStatuses[]
}

export const defaultCampaignsDashboardFilterState: CampaignsDashboardFilterState =
  {
    agencyIds: undefined,
    campaignStatuses: undefined,
    blankContractStatuses: undefined,
    launchDateStatuses: undefined,
    marketingStatuses: undefined,
  }

const campaignsDashboardFiltersKey = 'campaignsDashboardFilters'

const isValidEnumArray = <T extends string>(
  values: unknown,
  allowedValues: readonly T[]
): values is T[] =>
  Array.isArray(values) &&
  values.every(
    (value) => typeof value === 'string' && allowedValues.includes(value as T)
  )

export const storeCampaignsDashboardFilterState = (
  filters: CampaignsDashboardFilterState
) => {
  try {
    localStorage.setItem(campaignsDashboardFiltersKey, JSON.stringify(filters))
  } catch {
    // Ignore storage failures so the dashboard still works normally.
  }
}

export const createInitialCampaignsDashboardFilterState =
  (): CampaignsDashboardFilterState => {
    try {
      const storedFilterState = localStorage.getItem(
        campaignsDashboardFiltersKey
      )

      if (!storedFilterState) return defaultCampaignsDashboardFilterState

      const parsed = JSON.parse(
        storedFilterState
      ) as Partial<CampaignsDashboardFilterState> | null

      if (!parsed) return defaultCampaignsDashboardFilterState

      return {
        agencyIds: Array.isArray(parsed.agencyIds)
          ? parsed.agencyIds.filter(
              (value): value is string => typeof value === 'string'
            )
          : defaultCampaignsDashboardFilterState.agencyIds,
        campaignStatuses: isValidEnumArray(
          parsed.campaignStatuses,
          Object.values(CampaignStatuses)
        )
          ? parsed.campaignStatuses
          : defaultCampaignsDashboardFilterState.campaignStatuses,
        blankContractStatuses: isValidEnumArray(
          parsed.blankContractStatuses,
          Object.values(BlankContractStatuses)
        )
          ? parsed.blankContractStatuses
          : defaultCampaignsDashboardFilterState.blankContractStatuses,
        launchDateStatuses: isValidEnumArray(
          parsed.launchDateStatuses,
          Object.values(LaunchDateStatuses)
        )
          ? parsed.launchDateStatuses
          : defaultCampaignsDashboardFilterState.launchDateStatuses,
        marketingStatuses: isValidEnumArray(
          parsed.marketingStatuses,
          Object.values(MarketingStatuses)
        )
          ? parsed.marketingStatuses
          : defaultCampaignsDashboardFilterState.marketingStatuses,
      }
    } catch {
      return defaultCampaignsDashboardFilterState
    }
  }
